import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import axiosInstance from "../../../../lib/axios";
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

// Define columns for the print table
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "ItmGrpName", label: "Group Name", minWidth: 100 },
  { id: "ItmSubGrpName", label: "SubGroup Name", minWidth: 100 },
  { id: "ItmSubGrpAbrv", label: "Abbreviation", minWidth: 50 },
  { id: "UnitName", label: "Unit Name", minWidth: 100 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];

const ReipeSubGrp = () => {
  const { register, setValue, reset, watch, getValues } = useForm({
    defaultValues: {
      ItmGrpId: "",
      ItmSubGrpName: "",
      ItmSubGrpAbrv: "",
      UnitId: "",
      Remark: "",
      Status: "1",
    },
  });
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [ItmSubGrpId, setItmSubGrpId] = useState(-1);
  const [Mode, setMode] = useState("add");
  const [TransactionData, setTransactionData] = useState([]);
  const [GroupDrp, setGroupDrp] = useState([]);
  const [UnitDrp, setUnitDrp] = useState([]);
  const [TransformedGroupDrp, setTransformedGroupDrp] = useState([]);
  const [TransformedUnitDrp, setTransformedUnitDrp] = useState([]);
  const [OpenDForDelete, setOpenDForDelete] = useState(false);
  const [AllDisUnable, setAllDisUnable] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const contentRef = useRef(null);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const handlePrint = useReactToPrint({ contentRef });

  // Transform GroupDrp and UnitDrp for Autocomplete
  useEffect(() => {
    if (GroupDrp.length > 0) {
      const transformedGroups = GroupDrp.map((item) => ({
        Id: item.ItmGrpId,
        Name: item.ItmGrpName,
      }));
      setTransformedGroupDrp(transformedGroups);
    }
  }, [GroupDrp]);

  useEffect(() => {
    if (UnitDrp.length > 0) {
      const transformedUnits = UnitDrp.map((item) => ({
        Id: item.UnitId,
        Name: item.UnitName,
      }));
      setTransformedUnitDrp(transformedUnits);
    }
  }, [UnitDrp]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchGroupData();
      await fetchUnitData();
      await fetchDashboardData();

      if (location.state) {
        setAllDisUnable(false);
        let ItmSubGrpId = location.state.ItmSubGrpId;
        setItmSubGrpId(ItmSubGrpId);
        await fetchTransactionData(ItmSubGrpId, "R");
      } else {
        setMode("add");
        setAllDisUnable(true);
        resetFunc();
      }
    };

    fetchData();
  }, [location.state]);

  useEffect(() => {
    if (TransactionData.length > 0 && Mode !== "add") {
      const obj = TransactionData[0];
      setValue("ItmGrpId", obj.ItmGrpId || "");
      setValue("ItmSubGrpName", obj.ItmSubGrpName || "");
      setValue("ItmSubGrpAbrv", obj.ItmSubGrpAbrv || "");
      setValue("UnitId", obj.UnitId || "");
      setValue("Remark", obj.Remark || "");
      setValue("Status", obj.Status || "1");
      setAllDisUnable(false);
    }
  }, [TransactionData, Mode, setValue, getValues]);

  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.post(
        "MstItmSubGrp/GetMstItmSubGrpDashBoard",
        {
          start: 4,
          PageSize: 0,
          SearchText: "",
        }
      );
      if (res.data && res.data.Data) {
        setRows(res.data.Data);
        setDataForPrint(res.data.Data);
      } else {
        setRows([]);
        setDataForPrint({});
      }
    } catch (err) {
      toast.error("Error fetching dashboard data");
    }
  };

  const fetchGroupData = async () => {
    try {
      const response = await axiosInstance.post(
        `MstItmGrp/GetMstItmGrpDashBoard`,
        {
          start: 1,
          PageSize: 1,
          SearchText: "",
          Flag: "F"
        }
      );
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
      } else {
        toast.error("Error fetching Group data");
      }
    } catch (error) {
      toast.error("Error fetching group data");
    }
  };

  const fetchUnitData = async () => {
    try {
      const response = await axiosInstance.post(
        `MstUnit/GetMstUnitDashBoard`,
        {
          start: 4,
          PageSize: 0,
          SearchText: "",
        }
      );
      if (response.data.Status === 0) {
        setUnitDrp(response.data.Data);
      } else {
        toast.error("Error fetching Unit data");
      }
    } catch (error) {
      toast.error("Error fetching unit data");
    }
  };

  const fetchTransactionData = async (ItmSubGrpId, Flag) => {
    try {
      const response = await axiosInstance.post(
        `MstItmSubGrp/RetriveMstItmSubGrp`,
        {
          ItmSubGrpId,
          Flag,
        }
      );
      if (response.data.Status === 0) {
        if (Flag === "D") {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(ItmSubGrpId, "L");
          return;
        }
        let Data = response.data.Data != null ? response.data.Data : [];
        setTransactionData(Data);
        setItmSubGrpId(response.data.Data[0].ItmSubGrpId);
        setMode("view");
      } else {
        if (Flag !== "D") {
          setItmSubGrpId(-1);
          setMode("add");
          resetFunc();
        }
        toast.info(response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching Transaction data:", error);
    }
  };

  const handleAddClick = () => {
    setMode("add");
    setAllDisUnable(true);
    resetFunc();
  };

  const handleEditClick = async () => {
    let Flag = await checkAndLock(ItmSubGrpId, "MstItmSubGrp", "ItmSubGrpId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setAllDisUnable(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleCancelDButton = () => {
    setOpenDForDelete(false);
  };

  const handleSubmitClick = async () => {
    const Obj = getValues();
    console.log("Form state on submit:", Obj);
    if (!Obj.ItmGrpId || !Obj.ItmSubGrpName || !Obj.UnitId) {
      toast.info("Please Fill Required Field!");
      return;
    }

    let Payload = {
      ItmGrpId: Obj.ItmGrpId,
      ItmSubGrpName: Obj.ItmSubGrpName,
      ItmSubGrpAbrv: Obj.ItmSubGrpAbrv,
      UnitId: Obj.UnitId,
      Remark: Obj.Remark,
      Status: Obj.Status,
      CreatedBy: parseInt(UserId),
    };

    if (Mode === "add") {
      try {
        const response = await axiosInstance.post(
          `MstItmSubGrp/InsertMstItmSubGrp`,
          Payload
        );
        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(1, "L");
          setMode("view");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error("Error inserting data:", error);
      }
    } else {
      Payload = { ...Payload, ItmSubGrpId, UpdatedBy: parseInt(UserId) };
      delete Payload.CreatedBy;

      try {
        const response = await axiosInstance.post(
          `MstItmSubGrp/UpdateMstItmSubGrp`,
          Payload
        );
        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(ItmSubGrpId, "MstItmSubGrp", "ItmSubGrpId");
          fetchTransactionData(ItmSubGrpId, "R");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        toast.error("Error updating data:", error);
      }
    }
  };

  const handleCancelClick = async () => {
    if (ItmSubGrpId === -1 && Mode === "add") {
      await fetchTransactionData(1, "L");
    } else {
      await UnLock(ItmSubGrpId, "MstItmSubGrp", "ItmSubGrpId");
      await fetchTransactionData(ItmSubGrpId, "R");
    }
  };

  const handleGroupChange = (event, newValue) => {
    const selectedId = newValue ? newValue.Id : "";
    setValue("ItmGrpId", selectedId, { shouldValidate: true });
  };

  const handleUnitChange = (event, newValue) => {
    const selectedId = newValue ? newValue.Id : "";
    setValue("UnitId", selectedId, { shouldValidate: true });
  };

  const handleDeleteClick = () => {
    setOpenDForDelete(true);
  };

  const handleClickBackToTable = () => {
    navigate("/recipesub-table");
  };

  const handleConfirmDDelete = () => {
    fetchTransactionData(ItmSubGrpId, "D");
    setOpenDForDelete(false);
  };

  const handleNextClick = () => {
    fetchTransactionData(ItmSubGrpId, "N");
  };

  const handlePrevClick = () => {
    fetchTransactionData(ItmSubGrpId, "P");
  };

  const resetFunc = () => {
    reset({
      ItmGrpId: "",
      ItmSubGrpName: "",
      ItmSubGrpAbrv: "",
      UnitId: "",
      Remark: "",
      Status: "1",
    });
  };

  const handleCheckBoxChange = () => {
    setValue("Status", watch("Status") === "1" ? "0" : "1", {
      shouldValidate: true,
    });
  };

  return (
    <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
      <Dialog
        open={OpenDForDelete}
        onClose={handleCancelDButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do You Want To Delete The SubGroup?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCancelDButton}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
      <Grid container spacing={2} className="form_grid">
        <Grid
          item
          xs={12}
          className="form_title"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px",
            flexDirection: { xs: "column", sm: "row", md: "row" },
          }}
        >
          <Grid
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
              marginBottom: { xs: "10px", sm: 0 },
            }}
          >
            <Button
              variant="contained"
              size="small"
              className="three-d-button-previous"
              sx={{
                backgroundColor: "#635BFF",
                marginRight: { xs: "5px", sm: "10px" },
                display: { xs: "none", sm: "block" },
              }}
              onClick={handlePrevClick}
              disabled={AllDisUnable}
            >
              <KeyboardArrowLeftIcon />
            </Button>
            <Button
              variant="contained"
              size="small"
              className="three-d-button-next"
              sx={{
                backgroundColor: "#635BFF",
                display: { xs: "none", sm: "block" },
              }}
              onClick={handleNextClick}
              disabled={AllDisUnable}
            >
              <NavigateNextIcon />
            </Button>
          </Grid>

          <Typography
            variant="h5"
            sx={{
              margin: "Auto",
              textAlign: { xs: "center", sm: "center" },
              fontSize: { xs: "24px", sm: "18px", md: "24px" },
            }}
          >
            Recipe SubGroup Master
          </Typography>

          <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <CrudButtons
              moduleName="Recipe SubGroup"
              mode={Mode}
              onAdd={handleAddClick}
              onEdit={handleEditClick}
              onView={handlePrint}
              onDelete={handleDeleteClick}
              onExit={handleClickBackToTable}
              readOnlyMode={!AllDisUnable}
              onPrevious={handlePrevClick}
              onNext={handleNextClick}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={10} className="form_field" sx={{ marginX: "auto" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={5}>
              <Autocomplete
                options={TransformedGroupDrp}
                getOptionLabel={(option) => option.Name || ""}
                value={
                  TransformedGroupDrp.find(
                    (option) => option.Id === watch("ItmGrpId")
                  ) || null
                }
                onChange={handleGroupChange}
                disabled={!AllDisUnable}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Group List <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                  />
                )}
                noOptionsText="No groups available"
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="ItmSubGrpName"
                name="ItmSubGrpName"
                label={
                  <span>
                    SubGroup Name <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={watch("ItmSubGrpName") || ""}
                {...register("ItmSubGrpName")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="ItmSubGrpAbrv"
                name="ItmSubGrpAbrv"
                label="Abbreviation"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch("ItmSubGrpAbrv") || ""}
                {...register("ItmSubGrpAbrv")}
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <Autocomplete
                options={TransformedUnitDrp}
                getOptionLabel={(option) => option.Name || ""}
                value={
                  TransformedUnitDrp.find(
                    (option) => option.Id === watch("UnitId")
                  ) || null
                }
                onChange={handleUnitChange}
                disabled={!AllDisUnable}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Unit List <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                  />
                )}
                noOptionsText="No units available"
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="Remark"
                name="Remark"
                label="Remark"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch("Remark") || ""}
                {...register("Remark")}
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllDisUnable}
                      name="Status"
                      checked={watch("Status") === "1"}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="form_button">
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
            }}
            onClick={handleSubmitClick}
            disabled={!AllDisUnable}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
            }}
            onClick={handleCancelClick}
            disabled={!AllDisUnable}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>

      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="SubGroup Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
    </Box>
  );
};

export default ReipeSubGrp;